import { render } from "./ArgonButton.vue?vue&type=template&id=e45438ba&scoped=true"
import script from "./ArgonButton.vue?vue&type=script&lang=js"
export * from "./ArgonButton.vue?vue&type=script&lang=js"

import "./ArgonButton.vue?vue&type=style&index=0&id=e45438ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e45438ba"]])

export default __exports__